// Si el panel se puede instalar como app y cómo. Chrome/Edge disparan
// `beforeinstallprompt` cuando la PWA es instalable (solo en el panel: el
// manifest lo inyecta PwaManifest); se guarda ese evento para abrir el cuadro
// de instalación desde un botón propio. Ese evento no siempre llega (Chrome
// exige algo de uso de la página, no lo manda si la app ya está instalada, y
// iOS no lo tiene): sin él, el botón muestra las instrucciones del navegador.
// Un solo estado compartido: el menú se dibuja dos veces (escritorio y celular).
//
// No se llama a preventDefault(): Chrome sigue mostrando su propio aviso de
// instalación en Android, y el botón es una vía más.

import { useState, useEffect } from 'react';

let eventoInstalar = null;
let instaladaEnEstaVisita = false;
const suscriptores = new Set();

// Objeto nuevo en cada aviso: así también se redibuja cuando solo cambia
// instaladaEnEstaVisita (appinstalled llega con el evento ya descartado).
const avisar = () => suscriptores.forEach((fn) => fn({ evento: eventoInstalar }));

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    eventoInstalar = e;
    avisar();
  });
  window.addEventListener('appinstalled', () => {
    eventoInstalar = null;
    instaladaEnEstaVisita = true;
    avisar();
  });
}

// Solo para pruebas: vuelve al estado de una visita nueva.
export const reiniciarEstadoInstalacion = () => {
  eventoInstalar = null;
  instaladaEnEstaVisita = false;
  avisar();
};

const esStandalone = () =>
  (typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches) ||
  window.navigator.standalone === true;

const plataforma = () => {
  const ua = window.navigator.userAgent;
  // iPadOS se presenta como Mac: se reconoce por la pantalla táctil.
  if (/iphone|ipad|ipod/i.test(ua) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)) {
    return 'ios';
  }
  return /android/i.test(ua) ? 'android' : 'escritorio';
};

export default function usePwaInstall() {
  const [{ evento }, setEstado] = useState({ evento: eventoInstalar });

  useEffect(() => {
    suscriptores.add(setEstado);
    setEstado({ evento: eventoInstalar });
    return () => suscriptores.delete(setEstado);
  }, []);

  const instalada = esStandalone() || instaladaEnEstaVisita;

  // El evento solo sirve una vez: se descarta acepte o no, y Chrome manda
  // otro si vuelve a ser instalable.
  const instalar = async () => {
    if (!eventoInstalar) return null;
    const e = eventoInstalar;
    eventoInstalar = null;
    avisar();
    await e.prompt();
    const { outcome } = await e.userChoice;
    return outcome;
  };

  return {
    instalada,
    // true: el botón abre el cuadro del navegador; false: muestra instrucciones.
    puedeInstalar: !instalada && Boolean(evento),
    plataforma: plataforma(),
    instalar,
  };
}
